import EmberObject from '@ember/object';
import FilterConstants from '../../filter-constants';

export default class BaseImplementation extends EmberObject {
  getGbwTolerance(circuit, gbwTolerance) {
    var result = [];
    var gbw = circuit.opAmp.gbw;

    if (gbwTolerance === FilterConstants.gbwTolerance.twenty) {
      result.push(gbw * 0.8, gbw * 1, gbw * 1.2);
    } else {
      result.push(gbw);
    }

    return result;
  }

  getStageValuesFromCircuit(circuit) {
    return this.instance.getStageValuesFromCircuit(circuit);
  }
}
